module.exports = __webpack_public_path__ + "img/icon_shou@2x.1e7bb1e8.png";